import { ArpMediaType } from '@arpeggi/shared'
import { Box } from '@arpeggi/ui'
import { FC } from 'react'
import { OpenseaLogo } from '../../../__legacy__/components/core/icons'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useArpDetails, useCSSGradient } from '../hooks'
import { Card, Details, Section } from '../primitives'
import { ArpCollaboratorsCard } from './ArpCollaboratorsCard'
import { ArpSampleUsersCard } from './ArpSampleUsersCard'

export const ArpDetailsTabContent: FC<{ media: IArpMedia }> = ({ media }) => {
  const { mediaTableData, openSeaLink, tokenTableData, contractAddressDisplay, contractLink } =
    useArpDetails(media)
  const { color } = useCSSGradient(media)
  return (
    <Tabs.Content value="#details">
      <Section.Root>
        <Section.Flare1 css={{ color }} />
        <Section.Flare2 css={{ color }} />
        <Section.Content>
          <Details.Root>
            <Details.TwoColGrid>
              <Card.Root>
                <Card.Content>
                  <Box row justifyBetween alignStart>
                    <Card.Text title>Token Details</Card.Text>
                    <Card.Link href={openSeaLink} target="_blank">
                      <OpenseaLogo style={{ marginRight: '8px', width: '16px', height: '16px' }} />
                      View on Opensea
                    </Card.Link>
                  </Box>
                  {tokenTableData.map(({ key, value }) => (
                    <Box row justifyBetween key={key}>
                      <Card.Text bold>{key}</Card.Text>
                      <Card.Text>{value}</Card.Text>
                    </Box>
                  ))}
                  <Box row justifyBetween>
                    <Card.Text bold>Contract Address</Card.Text>
                    <Card.Text css={{ '&:hover': { textDecoration: 'underline' } }}>
                      <a href={contractLink} target="_blank">
                        {contractAddressDisplay}
                      </a>
                    </Card.Text>
                  </Box>
                </Card.Content>
              </Card.Root>
              <Card.Root>
                <Card.Content>
                  <Card.Text title>Media Details</Card.Text>
                  {mediaTableData.map(({ key, value }) => (
                    <Box row justifyBetween key={key}>
                      <Card.Text bold>{key}</Card.Text>
                      <Card.Text>{value}</Card.Text>
                    </Box>
                  ))}
                </Card.Content>
              </Card.Root>
            </Details.TwoColGrid>
            {media.type === ArpMediaType.SAMPLE ? (
              <ArpSampleUsersCard media={media} />
            ) : (
              <ArpCollaboratorsCard media={media} />
            )}
          </Details.Root>
        </Section.Content>
      </Section.Root>
    </Tabs.Content>
  )
}
